import { z } from 'zod';

export const GetCouponGoodsCategoriesServiceRequestSchema = z.object({
  couponNo: z.number().int(),
});

export type GetCouponGoodsCategoriesServiceRequest = z.infer<
  typeof GetCouponGoodsCategoriesServiceRequestSchema
>;

export const CouponGoodsCategoryDtoSchema = z.object({
  categoryCode: z.string(),
  categoryTitle: z.string(),
  goodsCount: z.number().int(),
});

export type CouponGoodsCategoryDto = z.infer<typeof CouponGoodsCategoryDtoSchema>;

export const GetCouponGoodsCategoriesServiceResponseSchema = z.object({
  list: z.array(CouponGoodsCategoryDtoSchema),
});

export type GetCouponGoodsCategoriesServiceResponse = z.infer<
  typeof GetCouponGoodsCategoriesServiceResponseSchema
>;
